import axios from "../axiosInstance";

export const getAllSkills = () =>
  axios.get("/skills").then(res => res.data);